/* eslint-disable no-bitwise */
import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

// import ALMOST_ZERO = marietta3d.AutoGen.utils.ALMOST_ZERO;
// import RC_INCLUDE = marietta3d.AutoGen.utils.RC_INCLUDE;

/**
* PointArray
* @export
* @class RoomPointArray
* @extends { Array<RoomPoint> }
*/
export default class RoomPointArray extends Array<marietta.core.Point> {
  /*------------------------------------------------------
    * Array の prototypeチェインを継承する.
    */
  // PointArray.prototype = new Array();

  /*------------------------------------------------------
    * 配列の座標すべてに引数を加算する
    */
  public Move(x: number, y: number): void {
    for (let i = 0; i < this.length; i += 1) {
      this[i].x += x;
      this[i].y += y;
    }
  }

  /*------------------------------------------------------
    * 配列の座標を center 中心に回転させる
    */
  public RotationRad(center: marietta.core.Point, rad: number): void {
    for (let i = 0; i < this.length; i += 1) {
      this[i].rotationRad(center, rad);
    }
  }

  /*------------------------------------------------------
    * 配列の座標を center 中心に回転させる
    */
  public Rotation(center: marietta.core.Point, ang: number): void {
    const rad = (ang / 180) * Math.PI;
    this.RotationRad(center, rad);
  }

  /*------------------------------------------------------
    * 指定配列からコピーする
    */
  public CopyFrom(plg: RoomPointArray): void {
    for (let i = 0; i < plg.length; i += 1) {
      this.push(new marietta.core.Point(plg[i].x, plg[i].y, plg[i].flag));
    }
  }

  /*------------------------------------------------------
    * 配列すべての要素の flag の値を設定する
    */
  public SetFlag(flag: number): void {
    for (let i = 0; i < this.length; i += 1) {
      this[i].flag = flag;
    }
  }

  /*------------------------------------------------------
    *
    */
  public IsSamePoint(p: marietta.core.Point): boolean {
    for (let i = 0; i < this.length; i += 1) {
      if (this[i].distanceTo(p) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
        return true;
      }
    }
    return false;
  }

  /* ##############################################################
    * 配列が表す多角形の線上に乗っているとき頂点を追加する（追加：true）。
    * 頂点一致はfalseで返る
    */
  public AddOnlinePoint(p: marietta.core.Point): boolean {
    if (this.IsSamePoint(p) === true) {
      // 頂点と一致
      return false;
    }
    for (let i = 0; i < this.length; i += 1) {
      const ln = this.GetLine(i);
      if (ln.DistancePtoEdge(p) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
        const pos = ln.LocationPtOnLine(p);
        if ((pos > 0.0) && (pos < 1.0)) {
          this.Insert((i + 1), new marietta.core.Point(p.x, p.y, ln.s.flag));
          return true;
        }
      }
    }
    return false;
  }

  /*------------------------------------------------------
    * 指定配列へコピーする
    */
  public CopyTo(plg: RoomPointArray): void {
    for (let i = 0; i < this.length; i += 1) {
      plg.push(new marietta.core.Point(this[i].x, this[i].y, this[i].flag));
    }
  }

  /*------------------------------------------------------
    * 指定された位置の頂点と次の頂点を Line で返す
    * 注意：Line の座標は多角形と別インスタンス
    */
  public CopyLine(pos: number): marietta3d.AutoGen.utils.RoomEdge {
    const posNum = (pos % this.length);
    const posNum2 = (posNum + 1) % this.length;
    const ln = new marietta3d.AutoGen.utils.RoomEdge();
    ln.CopyPointFrom(this[posNum], this[posNum2]);
    return ln;
  }

  /*------------------------------------------------------
    * 指定された位置の頂点と次の頂点を Line で返す
    * 注意：Line の座標は多角形のインスタンスを参照している
    */
  public GetLine(pos: number): marietta3d.AutoGen.utils.RoomEdge {
    const posNum = (pos % this.length);
    const posNum2 = (posNum + 1) % this.length;
    const ln = new marietta3d.AutoGen.utils.RoomEdge();
    ln.GetPointFrom(this[posNum], this[posNum2]);
    return ln;
  }

  /*------------------------------------------------------
    * 指定された位置の頂点と次の頂点を p1, p2 で返す
    * 注意：p1, p2 の座標は多角形と別インスタンス
    *（p1, p2のインスタンスを作ってから,本関数の引数に渡す事）
    */
  public CopyPoint(pos: number, p1: marietta.core.Point, p2: marietta.core.Point): void {
    const posNum = (pos % this.length);
    const posNum2 = (posNum + 1) % this.length;
    p1.copyFrom(this[posNum]);
    p2.copyFrom(this[posNum2]);
  }

  /*------------------------------------------------------
    * 終端に追加 (インスタンスをそのまま追加)
    */
  public Add(p: marietta.core.Point): void {
    this.push(p);
  }

  /*------------------------------------------------------
    * 終端に追加 (別インスタンスを作成して追加)
    */
  public AddNew(p: marietta.core.Point): void {
    this.push(new marietta.core.Point(p.x, p.y, p.flag));
  }

  /*------------------------------------------------------
    * 指定位置にインサート (インスタンスをそのまま追加)
    */
  public Insert(pos: number, p: marietta.core.Point): void {
    if (pos <= this.length) {
      this.splice(pos, 0, p);
    } else {
      throw new Error('PointArray.Insert : 範囲を超えています');
    }
  }

  /*------------------------------------------------------
    * 指定位置にインサート (別インスタンスを作成して追加)
    */
  public InsertNew(pos: number, p: marietta.core.Point): void {
    if (pos <= this.length) {
      this.splice(pos, 0, new marietta.core.Point(p.x, p.y, p.flag));
    } else {
      throw new Error('PointArray.InsertNew : 範囲を超えています');
    }
  }

  /*------------------------------------------------------
    * 指定位置を削除
    */
  public Remove(pos: number): void {
    if (pos < this.length) {
      this.splice(pos, 1);
    } else {
      throw new Error('PointArray.Remove : 範囲を超えています');
    }
  }

  /*------------------------------------------------------
    * 配列要素の全削除（要素もdeleteする）
    */
  public RemoveAll(): void {
    for (let i = 0; i < this.length; i += 1) {
      delete this[i];
    }
    this.splice(0, this.length);
  }

  /*------------------------------------------------------
    * 指定位置の要素の値の交換（インスタンスは変わらない。値が変わる）
    */
  public Swap(pos: number, pos2: number): void {
    if ((pos < this.length) && (pos2 < this.length)) {
      this[pos].swap(this[pos2]);
    } else {
      throw new Error('PointArray.Swap : 範囲を超えています');
    }
  }

  /*------------------------------------------------------
    * IsInclude
    * 点が領域に含まれるか。
    *
    * 与えられた点からの半直線を考え、半直線と多角形の交差する数が奇数なら、点は内側にある
    * 戻り値：
    *
    * 0 = 点は多角形の線上。
    * 1 = 点は多角形の内側
    * 2 = 点は多角形の外側
    *
    * public RC_INCLUDE = {
    *    ONLINE:  0,
    *    INSIDE:  1,
    *    OUTSIDE: 2,
    * }
    */
  public IsInclude(pnt: marietta.core.Point): number {
    /* 線分（辺）上の判定 */
    const pcnt = this.length;
    for (let i = 0; i < pcnt; i += 1) { /* 頂点の数だけループ */
      const ln = this.GetLine(i);

      /* 線上？ */
      if (ln.IsPtOnEdge(pnt) === true) {
        // return RC_INCLUDE.ONLINE;
        return 0;
      }
    }
    let cross = 0;
    let { x } = pnt;
    let retry = true;
    while (retry === true) {
      retry = false;
      let p1 = 0;
      while (p1 < pcnt) {
        const p2 = (p1 + 1) % pcnt;
        const ep = x - this[p1].x;
        const dt = this[p2].x - this[p1].x;
        const lmd = dt - ep;
        if ((Math.abs(ep) < 0.0001) || (Math.abs(lmd) < 0.0001)) {
          /* 半直線が多角形の頂点と交差している */
          retry = true;
          break;
        }
        if (((ep * dt) > 0.0) && (Math.abs(dt) > Math.abs(ep))) {
          const t = dt * (pnt.y - this[p1].y) - ep * (this[p2].y - this[p1].y);
          if ((ep > 0.0) && (lmd > 0.0) && (t > 0.0)) {
            cross += 1;
          } else if ((ep < 0.0) && (lmd < 0.0) && (t < 0.0)) {
            cross += 1;
          }
        }
        p1 += 1;
      }
      if (retry === true) {
        x += 0.0001; /* 微小移動 */
        cross = 0;
      }
    }
    if ((cross & 1) === 1) {
      // return RC_INCLUDE.INSIDE;   /* 奇数 */
      return 1;
    }
    // return RC_INCLUDE.OUTSIDE;  /*m 偶数 */
    return 2;
  }

  /*------------------------------------------------------
    * 点と領域の関係
    *
    * 戻り値：
    *
    * -2:領域外
    * -1:領域内
    * 0～na-1   : line上
    * na～2*na-1: 点上
    */
  public IsIncludeZ2(pnt: marietta.core.Point): number {
    if (this.length < 3) {
      return -2; /* 多角形でない。[領域外] */
    }
    let irc = -2;
    const min = new marietta.core.Point(0, 0, 0);
    const max = new marietta.core.Point(0, 0, 0);
    this.GetPolygonMinMax(min, max);
    if ((pnt.x < min.x) || (pnt.x > max.x)) return irc; /* [領域外] */
    if ((pnt.y < min.y) || (pnt.y > max.y)) return irc; /* [領域外] */
    const na = this.length;
    for (let isp = 0; isp < na; isp += 1) {
      if (pnt.distanceTo(this[isp]) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
        irc = isp + na;
        return irc; /* [頂点と一致] */
      }
      const ln = this.GetLine(isp);
      if (ln.IsPtOnEdge(pnt) === true) {
        irc = isp;
        return irc; /* [領域線上] */
      }
    }
    const rc = this.IsInclude(pnt);
    switch (rc) {
      case 0: return 0; /* [領域線上] */
      case 1: return -1; /* [領域内] */
      case 2: return -2; /* [領域外] */
      default: return null;
    }
  }

  //------------------------------------------------------
  // main , max を初期化してから処理する
  //
  public GetPolygonMinMax(min: marietta.core.Point, max: marietta.core.Point): void {
    const minPos = min;
    const maxPos = max;
    if (this.length === 0) {
      minPos.x = Number.MAX_VALUE;
      minPos.y = Number.MAX_VALUE;
      maxPos.x = Number.MIN_VALUE;
      maxPos.y = Number.MIN_VALUE;
    } else {
      minPos.x = this[0].x;
      minPos.y = this[0].y;
      maxPos.x = this[0].x;
      maxPos.y = this[0].y;
      for (let i = 1; i < this.length; i += 1) {
        if (this[i].x < minPos.x) minPos.x = this[i].x;
        if (this[i].x > maxPos.x) maxPos.x = this[i].x;
        if (this[i].y < minPos.y) minPos.y = this[i].y;
        if (this[i].y > maxPos.y) maxPos.y = this[i].y;
      }
    }
  }

  //------------------------------------------------------
  // min, max を初期化しない
  //
  public GetPolygonMinMaxAdd(min: marietta.core.Point, max: marietta.core.Point) {
    const minPos = min;
    const maxPos = max;
    if (this.length > 0) {
      for (let i = 0; i < this.length; i += 1) {
        if (this[i].x < min.x) minPos.x = this[i].x;
        if (this[i].x > max.x) maxPos.x = this[i].x;
        if (this[i].y < min.y) minPos.y = this[i].y;
        if (this[i].y > max.y) maxPos.y = this[i].y;
      }
    }
  }

  /*------------------------------------------------------
    */
  public CheckPolygonLineMinMax(ls: marietta.core.Point, le: marietta.core.Point): boolean {
    const pmin = new marietta.core.Point(0, 0, 0);
    const pmax = new marietta.core.Point(0, 0, 0);
    this.GetPolygonMinMax(pmin, pmax); /* 多角形の min max を求める */
    const lmin = new marietta.core.Point(0, 0, 0);
    const lmax = new marietta.core.Point(0, 0, 0);
    if (ls.x < le.x) {
      lmin.x = ls.x;
      lmax.x = le.x;
    } else {
      lmin.x = le.x;
      lmax.x = ls.x;
    }
    if (ls.y < le.y) {
      lmin.y = ls.y;
      lmax.y = le.y;
    } else {
      lmin.y = le.y;
      lmax.y = ls.y;
    }
    if (lmax.x < pmin.x) return false;
    if (lmin.x > pmax.x) return false;
    if (lmax.y < pmin.y) return false;
    if (lmin.y > pmax.y) return false;
    return true;
  }

  /*------------------------------------------------------
    * 多角形が反時計回りのとき true を返す
    */
  public IsPolygonLeftTurn(): boolean {
    let g = 0.0;
    const cnt = this.length;
    for (let i = 0; i < cnt; i += 1) {
      const j = (i + 1) % cnt;
      g += this[i].getVectorProduct(this[j]);
    }
    if (g >= 0.0) return true;
    return false;
  }

  /*------------------------------------------------------
    * 多角形が左回り（反時計回り）になるよう頂点を入れ替える。
    *
    * mode
    *   0:先頭が最後になる      ([n-1]...[2][1][0]
    *   1:１点目不動の入れ替え  ([0][n-1]......[1]
    *   2: １・２点目の入れ替え ([1][0][n-1]...[2] (１・２点目が表す線分を先頭にしたい時)
    */
  public GetPolygonLeftTurn(mode: number) {
    if (this.IsPolygonLeftTurn() === false) {
      let i: number;
      let j: number;
      const n = this.length;
      if (mode === 0) { /* 現状通りの入れ替え(先頭が最後になる) */
        for (i = 0, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      } else if (mode === 1) { /* １点目不動の入れ替え */
        for (i = 1, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      } else { /* １・２点目の入れ替え */
        this[0].swap(this[1]);
        for (i = 2, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      }
      /* flag が表す区間がズレるので修正 */
      let flg = this[0].flag;
      let wflg: number;
      for (i = this.length - 1; i >= 0; i -= 1) {
        wflg = this[i].flag;
        this[i].flag = flg;
        flg = wflg;
      }
    }
  }

  /*------------------------------------------------------
    * 多角形が右回り（時計回り）になるよう頂点を入れ替える。
    *
    * mode
    *   0:先頭が最後になる      ([n-1]...[2][1][0]
    *   1:１点目不動の入れ替え  ([0][n-1]......[1]
    *   2: １・２点目の入れ替え ([1][0][n-1]...[2] (１・２点目が表す線分を先頭にしたい時)
    */
  public GetPolygonRightTurn(mode: number) {
    if (this.IsPolygonLeftTurn() === true) {
      let i: number;
      let j: number;
      const n = this.length;
      if (mode === 0) { /* 現状通りの入れ替え(先頭が最後になる) */
        for (i = 0, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      } else if (mode === 1) { /* １点目不動の入れ替え */
        for (i = 1, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      } else { /* １・２点目の入れ替え */
        this[0].swap(this[1]);
        for (i = 2, j = n - 1; i < j; i += 1, j -= 1) {
          this[i].swap(this[j]);
        }
      }
      /* flag が表す区間がズレるので修正 */
      let flg = this[0].flag;
      let wflg: number;
      for (i = this.length - 1; i >= 0; i -= 1) {
        wflg = this[i].flag;
        this[i].flag = flg;
        flg = wflg;
      }
    }
  }

  /*------------------------------------------------------
    * 領域点の間引き
    *
    * 戻り値が true のとき、頂点列に重複があることを表す。（処理を中断する）
    */
  public RemovePtInPolygon(): boolean {
    let iNum = this.length;
    let bRet = false;
    if (iNum <= 1) return bRet; // 間引きする必要無し
    let i: number;
    let i2: number;
    let i3: number;
    const fArray = [];
    const wArray = new RoomPointArray();
    wArray.CopyFrom(this);
    for (i = 0; i < iNum; i += 1) {
      fArray.push(0);
    }
    for (i = 0; i < iNum; i += 1) {
      i2 = (i + 1) % iNum;
      const ln1 = this.GetLine(i);
      const p1 = ln1.e.getSubVectorZ2(ln1.s); /* p1 = (ln1.e - ln1.s ) */
      /* if (Math.abs(p1.x) < 2.0 && Math.abs(p1.y) < 2.0) {
        fArray[i2] = 1;
        continue;
      } */
      if (Math.abs(p1.x) < 2.0 && Math.abs(p1.y) < 2.0) {
        fArray[i2] = 1;
      } else {
        i3 = (i2 + 1) % iNum;
        const ln2 = this.GetLine(i2);
        const p2 = ln2.e.getSubVectorZ2(ln2.s); /* p2 = (ln2.e - ln2.s ) */
        /* if (Math.abs(p2.x) < 2.0 && Math.abs(p2.y) < 2.0) {
          fArray[i3] = 1;
          continue;
        } */
        if (Math.abs(p2.x) < 2.0 && Math.abs(p2.y) < 2.0) {
          fArray[i3] = 1;
        } else if (Math.abs(p1.getVectorProduct(p2)) < 2.0) {
          /* 平行 */
          if (p1.getInnerProduct(p2) < 0.0) {
            /* 平行 && 逆向き */
            bRet = true;
            break;
          } else {
            /* 同じ向き */
            /* i2 の点は必要ない */
            fArray[i2] = 1;
          }
        }
      }
    }
    if (bRet === false) {
      this.RemoveAll();
      for (i = 0; i < iNum; i += 1) {
        if (fArray[i] === 0) {
          this.AddNew(wArray[i]);
        }
      }
      if (fArray[0] === 1) {
        /* 第１頂点が捨てられたとき */
        iNum = this.length;
        const w1 = new marietta.core.Point(0, 0, 0);
        w1.copyFrom(this[iNum - 1]); /* 最終点を取り出して */
        for (i = 0; i < iNum; i += 1) {
          w1.swap(this[i]); /* 先頭から順に入れ替えていく */
        }
      }
    }
    wArray.RemoveAll();
    fArray.splice(0, fArray.length);
    return bRet;
  }

  /*------------------------------------------------------
    * 値 t を小さい順に座標配列のＸに登録する。同一値は登録しない
    *
    */
  public PtSort(t: number, est: number): boolean {
    if (arguments.length !== 2) {
      throw new Error('PointArray.PtSort : 引数の数が合いません');
    }
    for (let i = 0; i < this.length; i += 1) {
      if (Math.abs(t - this[i].x) < est) {
        // 既に同一値が登録されている
        return false;
      } if (t < this[i].x) {
        this.Insert(i, new marietta.core.Point(t, 0, 0));
        return true;
      }
    }
    this.Add(new marietta.core.Point(t, 0, 0));
    return true;
  }

  /*------------------------------------------------------
    * 多角形と線分の交点計算を行い、多角形に含まれる線分を座標配列で返す
    *
    * this: 多角形
    *  ls: 始点
    *  le: 終点
    *  cr: 線分の始終点を格納する配列
    * lineMode: 与えられた線分を直線として扱うとき：true
    *      est: 許容距離
    * f_inside: 多角形の内側の線を返す：true
    * f_online: 多角形の線上を有効にする：true
    *
    * 戻り値:線分数
    */
  public IsIncludeLineAtPolygon(ls: marietta.core.Point, le: marietta.core.Point, cr: RoomPointArray, lineMode: boolean, est: number, inside: boolean, online: boolean): number {
    if (lineMode === false) {
      /* 線分モードの時のみチェックする */
      if (this.CheckPolygonLineMinMax(ls, le) === false) {
        /* ＭｉｎＭａｘが干渉しない */
        if (inside === false) {
          /* 多角形の外側の線分を返すのであればこの線分は有効 */
          cr.AddNew(ls);
          cr.AddNew(le);
          return 1;
        }
        return 0;
      }
    }
    let x = le.x - ls.x;
    let y = le.y - ls.y;
    let d = x * x + y * y;
    if (d < 1.0) {
      /* 線分の長さがゼロ */
      return 0;
    }
    /* 線分がＸ軸の 0.0 から +1.0 に重なるように、多角形を座標変換する */
    d = Math.sqrt(d); // 座標変換時の全体の図形の縮尺比（縮小値） */
    const c = x / d; /* Ｘ軸方向の縮尺比 */
    const s = y / d; /* Ｙ               */
    /* 許容値を縮尺に合わせる */
    let permit = (est / d);
    if (permit < Number.MIN_VALUE) permit = Number.MIN_VALUE;
    let cnt: number;
    let i: number;
    let j: number;
    cnt = this.length;
    const p1 = new marietta.core.Point(0, 0, 0);
    const p2 = new marietta.core.Point(0, 0, 0);
    let fx: number;
    let fy: number;
    const wPlg = new RoomPointArray(); /* 座標変換後の多角形の頂点配列用 */
    /* 多角形を座標変換する */
    for (i = 0; i < cnt; i += 1) {
      p1.copyFrom(this[i]);
      x = p1.x - ls.x;
      y = p1.y - ls.y;
      fx = (((x * c) + (y * s)) / d);
      fy = (((-x * s) + (y * c)) / d);
      wPlg.Add(new marietta.core.Point(fx, fy, 0));
    }
    /* 求めた多角形がＸ軸と交差、または接触するＸ座標を求めて、小さい順に並べる */
    const work = new RoomPointArray();
    if (lineMode === false) {
      /* 線分モードの時のみ、線分の始点／終点を追加する */
      work.PtSort(0.0, permit);
      work.PtSort(1.0, permit);
    }
    for (i = 0; i < cnt; i += 1) {
      j = (i + 1) % cnt;
      p1.copyFrom(wPlg[i]);
      p2.copyFrom(wPlg[j]);
      /* 交点があるか調べる */
      if ((p1.y * p2.y) < 0.0) {
        /* 掛けた値がマイナス ＝ 符号が異なる ＝ X軸をマタイダ */
        const t = -(p1.y) / (p2.y - p1.y);
        fx = ((p2.x - p1.x) * t + p1.x);
        if (lineMode === true) {
          /* 直線モード（すべての交点が有効） */
          work.PtSort(fx, permit);
        } else if ((fx >= 0.0) && (fx <= 1.0)) { /* 線分モード（線分上の交点のみ有効） */
          work.PtSort(fx, permit);
        }
      } else if (Math.abs(p1.y) < permit) {
        if (lineMode === true) {
          /* 直線モード（すべての交点が有効） */
          work.PtSort(p1.x, permit);
        } else if ((p1.x >= 0.0) && (p1.x <= 1.0)) { /* 線分モード（線分上の交点のみ有効） */
          work.PtSort(p1.x, permit);
        }
      } else if (Math.abs(p2.y) < permit) {
        if (lineMode === true) {
          /* 直線モード（すべての交点が有効） */
          work.PtSort(p2.x, permit);
        } else if ((p2.x >= 0.0) && (p2.x <= 1.0)) { /* 線分モード（線分上の交点のみ有効） */
          work.PtSort(p2.x, permit);
        }
      }
    }
    wPlg.RemoveAll();
    /* 交点列を元の座標に戻す */
    const work2 = new RoomPointArray();
    for (i = 0; i < work.length; i += 1) {
      x = work[i].x * d;
      fx = (x * c + ls.x);
      fy = (x * s + ls.y);
      work2.Add(new marietta.core.Point(fx, fy, 0));
    }
    work.RemoveAll(); /* 全削除 */
    /* 求めた交点の各区間の中点を求め、多角形とのインクルード・テストを行い、 */
    /* 「内側」だったら、その区間を線分として出力配列に登録する */
    cnt = work2.length;
    let mid: any;
    let lcnt = 0;
    for (i = 0; i < (cnt - 1); i += 1) {
      const ln = work2.GetLine(i); /* 交点をペアで取り出す */
      /* ２つの交点の中点を求める */
      mid = ln.GetMidPoint();
      if (inside === true) {
        /* 多角形の内側を有効とする */
        if (online === true) {
          /* 境界線上を含む */
          if (this.IsInclude(mid) !== marietta3d.AutoGen.utils.RC_INCLUDE.OUTSIDE) {
            cr.AddNew(ln.s);
            cr.AddNew(ln.e);
            lcnt += 1;
          }
        } else if (this.IsInclude(mid) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) { /* 境界線上は含まない */
          cr.AddNew(ln.s);
          cr.AddNew(ln.e);
          lcnt += 1;
        }
      } else if (online === true) { /* 多角形の外側を有効とする */
        /* 境界線上を含む */
        if (this.IsInclude(mid) !== marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
          cr.AddNew(ln.s);
          cr.AddNew(ln.e);
          lcnt += 1;
        }
      } else if (this.IsInclude(mid) === marietta3d.AutoGen.utils.RC_INCLUDE.OUTSIDE) { /* 境界線上は含まない */
        cr.AddNew(ln.s);
        cr.AddNew(ln.e);
        lcnt += 1;
      }
    }
    work2.RemoveAll(); /* 全削除 */
    return lcnt;
  }

  /*------------------------------------------------------
    * ２つの領域の重なり判定
    *
    * Return Code 0:領域が離れている
    *  1:同一領域
    *  2:重なりあり
    *  3:接している(外接(点接触を含む))
    *  4:ＢがＡに含まれる
    *  5:ＢがＡに含まれる(内接(点接触を含む))
    *  6:ＡがＢに含まれる
    *  7:ＡがＢに含まれる(内接(点接触を含む))
    public RC_INCLP = {
        AWAY: 0,
        SAME: 1,
        OVERLAP: 2,
        OUTSIDE_CONTACT: 3,
        INCLUDE_BY_A: 4,
        INCLUDE_BY_A_CONTACT: 5,
        INCLUDE_BY_B: 6,
        INCLUDE_BY_B_CONTACT: 7,
    }
    */
  /*------------------------------------------------------
    */

  public IsIncludePolygon(bp: RoomPointArray): number {
    const TOL = 2.0;
    let irc = this.IsIncludePolygonZ2(bp);
    if (irc === 3 || irc === 5 || irc === 7) {
      for (let i = 0; i < this.length; i += 1) {
        const ln1 = this.GetLine(i);
        for (let j = 0; j < bp.length; j += 1) {
          const ln2 = bp.GetLine(j);
          if (ln1.IsOverlapLine(ln2) > TOL) {
            return irc;
          }
        }
      }
      // ここまで残ったという事は点接触
      switch (irc) {
        case 3: irc = 0; break;
        case 5: irc = 4; break;
        case 7: irc = 6; break;
        default: break;
      }
    }
    return irc;
  }

  /*------------------------------------------------------
    * ２つの領域の重なり判定
    *
    * Return Code 0:領域が離れている
    *  1:同一領域
    *  2:重なりあり
    *  3:接している(外接(点接触を含む))
    *  4:ＢがＡに含まれる
    *  5:ＢがＡに含まれる(内接(点接触を含む))
    *  6:ＡがＢに含まれる
    * 7:ＡがＢに含まれる(内接(点接触を含む))
    */
  public IsIncludePolygonZ2(Bp: RoomPointArray): number {
    const TOL = 2.0;
    const TOLSQ = 4.0;
    let irc: any;
    let i1: number; let i2: number; let j1: number; let
      j2: number;
    let la: any;
    let lb: any;
    const ap = new RoomPointArray();
    const bp = new RoomPointArray();
    ap.CopyFrom(this);
    bp.CopyFrom(Bp);
    let setu = false; /* 接してる */
    let AinB = false; /* Ａの一部がＢに含まれる */
    let AoutB = false; /* Aの一部がＢの外部にある */
    let BinA = false; /* Ｂの一部がＡに含まれる */
    let BoutA = false; /* Ｂ一部がＡの外部にある */
    {
      i1 = 0; j1 = 0;
      let conta = ap.length;
      while (i1 < conta) {
        i2 = (i1 + 1) % conta;
        la = ap.GetLine(i1);
        j1 = 0;
        let contb = bp.length;
        while (j1 < contb) {
          j2 = (j1 + 1) % contb;
          lb = bp.GetLine(j1);
          /* 二つ線分を比べて交点があったら両方に追加 */
          /* lb.sが線分Ａにあった場合lb.sを囲みに追加 */
          /* IntersectionLineZ2で重なった情況を判断できないので先ず点接を考える */

          irc = la.IsPtOnEdgeZ2(lb.s, TOL);
          if (irc === 0) { /* 線分の中 */
            if (i2 === 0) {
              ap.AddNew(lb.s);
              la.e = lb.s;
              conta += 1;
              i2 = conta - 1;
              setu = true;
              // continue;
            } else {
              ap.InsertNew(i2, lb.s);
              la.e = lb.s;
              conta += 1;
              setu = true;
              // continue;
            }
          } else {
            if (irc > 0) {
              if (irc === 1 || irc === 2) setu = true;
            }
            /* asが線分Bにあった場合asを囲みに追加 */

            irc = lb.IsPtOnEdgeZ2(la.s, TOL);
            if (irc === 0)/* 線分の中 */ {
              if (j2 === 0) {
                bp.AddNew(la.s);
                lb.e = la.s;
                contb += 1;
                j2 = contb - 1;
                j1 += 1;
                setu = true;
                // continue;
              } else {
                bp.InsertNew(j2, la.s);
                lb.e = la.s;
                contb += 1;
                j1 += 1;
                setu = true;
                // continue;
              }
            } else if (irc > 0) {
              if (irc === 1 || irc === 2) setu = true;
              j1 += 1;
              // continue;
            } else {
              const pp = new marietta.core.Point(0, 0, 0); /* 交点 */
              const rc = new marietta.core.Point(0, 0, 0); /* 特殊：線分１の結果：ｘ、線分２の結果：ｙ */
              irc = la.IntersectionLineZ2(lb, pp, rc, TOLSQ);
              if (irc === 0 && rc.x === 0 && rc.y === 0)/* 交点あり */ {
                return 2;/* 重なりあり */
              }
              j1 += 1;
            }
          }
        }
        i1 += 1;
      }
    }
    /* 接してるかは判断すみ */
    /* 線分の中点で相手の領域との関係を判断 */
    {
      let ce: any;
      i1 = 0;
      j1 = 0;
      const conta = ap.length;
      while (i1 < conta) {
        la = ap.GetLine(i1);
        ce = la.GetMidPoint();
        irc = bp.IsIncludeZ2(ce);
        if (irc === -1) { /* 領域内 */
          if (AoutB) return 2;
          AinB = true;
        }
        if (irc === -2) { /* 領域外 */
          if (AinB) return 2;
          AoutB = true;
        }
        i1 += 1;
      }
      i1 = 0;
      j1 = 0;
      const contb = bp.length;
      while (i1 < contb) {
        lb = bp.GetLine(i1);
        ce = lb.GetMidPoint();
        irc = ap.IsIncludeZ2(ce);
        if (irc === -1) { /* 領域内 */
          if (BoutA) return 2;
          BinA = true;
        }
        if (irc === -2) { /* 領域外 */
          if (BinA) return 2;
          BoutA = true;
        }
        i1 += 1;
      }
    }
    /* フラグ判断終了 */
    /* フラグによって結果を出す */
    if (AinB) { /* その時AoutB === FALSE はず */
      if (BinA) {
        return 2;
      }
      if (BoutA) { /* aがＢに含まれる */
        if (setu) {
          return 7; /* 7:ＡがＢに含まれる(内接(点接触を含む)) */
        }
        return 6; /* 6:ＡがＢに含まれる */
      }
      if (setu) {
        return 7; /* 7:ＡがＢに含まれる(内接(点接触を含む)) */
      }
      return 6; /* 6:ＡがＢに含まれる */
    }
    if (AoutB) {
      if (BinA) {
        /* BがAに含まれる */
        /* BoutA === FALSE はず */
        if (setu) {
          return 5; /* 5:ＢがＡに含まれる(内接(点接触を含む)) */
        }
        return 4; /* 4:ＢがＡに含まれる */
      }
      if (BoutA) {
        /* 0:領域が離れている */
        if (setu) {
          return 3; /* 3:接している(外接(点接触を含む)) */
        }
        return 0; /* 0:領域が離れている */
      }
      if (setu) {
        return 5; /* 5:ＢがＡに含まれる(内接(点接触を含む)) */
      }
      return 4; /* 4:ＢがＡに含まれる */
    }
    if (BinA) {
      if (setu) {
        return 5; /* 5:ＢがＡに含まれる(内接(点接触を含む)) */
      }

      return 4; /* 4:ＢがＡに含まれる */
    }
    if (BoutA) {
      if (setu) {
        return 7; /* 7:ＡがＢに含まれる(内接(点接触を含む)) */
      }

      return 6; /* 6:ＡがＢに含まれる */
    }
    return 1; /* 1:同一領域 */
  }

  /*------------------------------------------------------
    * 多角形のオフセット。計算後別インスタンスで返す
    *
    * this :多角形の頂点座標配列
    * OutPoly :オフセット後の多角形の頂点座標配列
    * Offset :(+)線分の左側、(-)右側（反時計回りでは、(+)縮小、(-)拡大になる）
    * OffsetFlag:ゼロの時：多角形の最初の点に相当するオフセット後の点が最終点になる。
    * :ゼロ以外の時：多角形の最初の点に相当するオフセット後の点が先頭になる。
    */
  public GetOffsetPolygon(OutPoly: RoomPointArray, Offset: number, OffsetFlag: number) {
    const cr = new marietta.core.Point(0, 0, 0);
    const first = new marietta3d.AutoGen.utils.RoomEdge();
    const ln1 = this.CopyLine(0); /* 別インスタンス */
    let ln2: any;
    ln1.GetOffsetEdge(Offset);
    first.CopyFrom(ln1);
    for (let Pos = 1; Pos < this.length; Pos += 1) {
      ln2 = this.CopyLine(Pos); /* 別インスタンス */
      ln2.GetOffsetEdge(Offset);
      if (ln1.IntersectionLine(ln2, cr) === true) {
        cr.flag = ln1.e.flag;
        OutPoly.AddNew(cr);
        ln1.s.copyFrom(ln2.s);
        ln1.e.copyFrom(ln2.e);
      } else {
        OutPoly.AddNew(ln1.e);
        ln1.e.copyFrom(ln2.e);
      }
    }
    /* 多角形の最初の点に相当するオフセット後の点を、先頭か最後に加える */
    if (first.IntersectionLine(ln1, cr) === true) {
      cr.flag = ln1.e.flag;
      if (OffsetFlag === 0) {
        OutPoly.AddNew(cr); /* 最後に追加する */
      } else {
        OutPoly.InsertNew(0, cr); /* 先頭に加える */
      }
    } else if (OffsetFlag === 0) { /* 交点が無い＝平行。よって、ln1 の終点を登録（しなくても良い？） */
      OutPoly.AddNew(ln1.e); /* 最後に追加する */
    } else {
      OutPoly.InsertNew(0, ln1.e); /* 先頭に加える */
    }
  }

  /* ##############################################################
    * 多角形の面積
    */
  public GetPolyArea(): number {
    let g = 0.0;
    const cnt = this.length;
    if (cnt < 3) return 0;
    for (let i = 0; i < cnt; i += 1) {
      const j = (i + 1) % cnt;
      g += this[i].getVectorProduct(this[j]);
    }
    return Math.abs(g) / 2;
  }

  /* ##############################################################
    * 多角形の周囲の長さ
    */
  public GetPolyCircum(): number {
    const cnt = this.length;
    let line = 0.0;
    if (cnt < 1) return 0;
    for (let i = 0; i < cnt; i += 1) {
      const ln = this.GetLine(i);
      line += ln.Length();
    }
    return line;
  }

  /*------------------------------------------------------
    * 多角形（plg）を多角形（this）でカットする
    *
    * this  : カットする多角形
    * plg   : カットされる多角形
    * result: カット後の多角形のリスト
    *
    * 戻り値:線分数
    */
  public CutPolygonByPolygon(plg: RoomPointArray, result: Array<RoomPointArray>): number {
    if (plg.length === 0 || this.length === 0) {
      return 0;
    }
    const plg1 = new RoomPointArray();
    const plg2 = new RoomPointArray();
    plg1.CopyFrom(plg);
    plg2.CopyFrom(this);
    const ret = plg1.IsIncludePolygon(plg2);
    if (ret === 0) {
      result.push(plg1);
      return ret; // 独立
    }
    if (ret === 1 || ret === 4 || ret === 6 || ret === 7) {
      return ret;
    }
    plg1.GetPolygonLeftTurn(1);
    plg2.GetPolygonRightTurn(1);
    const line = new RoomPointArray();
    const flg = [];
    plg1.CutPolygonByPolygonSub(plg2, line, true);
    plg2.CutPolygonByPolygonSub(plg1, line, false);
    if (line.length === 0) return ret;
    for (let i = 0; i < line.length; i += 1) {
      flg.push(0);
    }
    line.MakePolygonFromEdge(result, flg);

    return ret;
  }

  /*------------------------------------------------------
    * カットポリゴンに必要な線分を抽出する（CutPolygonByPolygonの内部関数）
    *
    */
  public CutPolygonByPolygonSub(plg2: RoomPointArray, line: RoomPointArray, sw: boolean) {
    const cr = new marietta.core.Point(0, 0, 0);
    for (let i = 0; i < this.length; i += 1) {
      const ko = new RoomPointArray();
      const ln = this.GetLine(i);
      let ang1 = new marietta.core.Point(ln.s.x, ln.s.y, ln.s.flag).angle(new marietta.core.Point(ln.e.x, ln.e.y, ln.e.flag));
      if (ang1 < 0.0001) ang1 = 360.0;
      ko.AddNew(ln.s);
      ko.AddNew(ln.e);
      for (let j = 0; j < plg2.length; j += 1) {
        const ln2 = plg2.GetLine(j);
        if (ln.IntersectionLine(ln2, cr)) {
          if ((ln.DistancePtoEdge(cr) <= 1) && (ln2.DistancePtoEdge(cr) <= 1)) {
            let found = false;
            for (let k = 0; k < ko.length; k += 1) {
              if (cr.distanceTo(ko[k]) < 1) {
                found = true;
                break;
              }
            }
            if (found === false) {
              ko.AddNew(cr);
            }
          }
        }
      }
      ko.PointSort(ln.s, ln.e);
      for (let j = 0; j < ko.length - 1; j += 1) {
        const lnc = ko.GetLine(j);
        const mid = lnc.GetMidPoint();
        let flg = false;
        for (let ii = 0; ii < plg2.length; ii += 1) {
          const ln2 = plg2.GetLine(ii);
          let ang2 = new marietta.core.Point(ln2.s.x, ln2.s.y, ln2.s.flag).angle(new marietta.core.Point(ln2.e.x, ln2.e.y, ln2.e.flag));
          if (ang2 < 0.0001) ang2 = 360.0;
          const off = ln2.DistancePtoEdge(mid);
          if (off < 1) {
            if (sw) {
              if (Math.abs(ang1 - ang2) < 1) {
                flg = true;
                if (ln2.DistancePtoEdge(lnc.s) < 1 && ln2.DistancePtoEdge(lnc.e) < 1) {
                  line.AddNew(lnc.s);
                  line.AddNew(lnc.e);
                  break;
                }
              }
            }
          }
        }
        if (flg === false) {
          const wln = new marietta3d.AutoGen.utils.RoomEdge();
          wln.CopyFrom(lnc);
          wln.GetOffsetEdge(1);
          const mid2 = wln.GetMidPoint();
          if (this.IsInclude(mid2) === 2) {
            wln.GetOffsetEdge(-2);
          }
          const ret = plg2.IsInclude(mid2);
          if ((sw && ret === 2) || (!sw && ret === 1)) {
            line.AddNew(lnc.s);
            line.AddNew(lnc.e);
          }
        }
      }
    }
  }

  /*------------------------------------------------------
    * 線分から囲みを作成する（MargePolygonの内部関数）
    *
    *
    */
  public MakePolygonFromEdge(polAry: Array<RoomPointArray>, flg: Array<number>) {
    const flgArr = flg;
    for (let i = 0; i < this.length; i += 2) {
      // if (flg[i] == 9) continue;
      if (flg[i] !== 9) {
        const ln = this.CopyLine(i);
        const ary = new RoomPointArray();
        ary.AddNew(ln.s);
        flgArr[i] = 9;
        ary.MakePolygonFromEdgeSub(this, flg, ln.s, ln.e);
        if (ary.length > 2) {
          ary.RemovePtInPolygon();
          polAry.push(ary);
        } else {
          ary.RemoveAll();
        }
      }
    }
  }

  /*------------------------------------------------------
    * 線分から囲みを作成する （MakePolygonFromEdgeの内部関数）
    *
    *
    */
  public MakePolygonFromEdgeSub(lin: RoomPointArray, flg: Array<number>, p1: marietta.core.Point, p2: marietta.core.Point) {
    const flgArr = flg;
    for (;;) {
      const no = [];
      // p2と同じ座標を見つけて、そのIndexをno配列にセット
      for (let i = 0; i < lin.length; i += 2) {
        // if (flg[i] == 9) continue;
        if ((flg[i] !== 9) && (p2.distanceTo(lin[i]) < 1)) {
          no.push(i);
        }
      }
      if (no.length === 0) return; // p2 と同じ座標が無かった
      if (no.length === 1) {
        const ln = lin.CopyLine(no[0]);
        this.AddNew(ln.s);
        flgArr[no[0]] = 9;
        p1.copyFrom(ln.s);
        p2.copyFrom(ln.e);
      } else {
        // 元に戻さないと、端点と端点が接続する場合に囲みが１つになる
        let sa = 2.0 * Math.PI; // 360
        const ka = new marietta.core.Point(p2.x, p2.y, p2.flag).angle(new marietta.core.Point(p1.x, p1.y, p1.flag));
        let n = -1;
        for (let j = 0; j < no.length; j += 1) {
          const ln = lin.GetLine(no[j]);
          let ka2 = new marietta.core.Point(ln.s.x, ln.s.y, ln.s.flag).angle(new marietta.core.Point(ln.e.x, ln.e.y, ln.e.flag));
          if (ka2 > ka) ka2 -= 2.0 * Math.PI;
          if ((ka - ka2) < sa) {
            sa = ka - ka2;
            n = j;
          }
        }
        if (n > -1) {
          const ln = lin.CopyLine(no[n]);
          this.AddNew(ln.s);
          flgArr[no[n]] = 9;
          p1.copyFrom(ln.s);
          p2.copyFrom(ln.e);
        }
      }
      if (p2.distanceTo(this[0]) < 1) break;
    }
  }

  /*------------------------------------------------------
    * Array型の座標配列を、p1からp2方向へソートする
    *
    */
  public PointSort(p1: marietta.core.Point, p2: marietta.core.Point) {
    const w1 = p2.x - p1.x;
    const w2 = p2.y - p1.y;
    let i: number;
    let j: number;
    const d: number = Math.sqrt(w1 * w1 + w2 * w2);
    if (d < 1.0) {
      return;
    }
    const cost: number = w1 / d;
    const sint: number = w2 / d;
    for (i = 0; i < this.length; i += 1) {
      const p = this[i];
      p.flag = (cost * p.x + sint * p.y);
    }
    for (i = 0; i < this.length - 1; i += 1) {
      for (j = i + 1; j < this.length; j += 1) {
        if (this[i].flag > this[j].flag) {
          this[i].swap(this[j]);
        }
      }
    }
    this.RemoveSamePoint();
  }

  /*------------------------------------------------------
    * 配列内の同じ座標を削除する
    *
    */
  public RemoveSamePoint() {
    if (arguments.length !== 0) {
      throw new Error('PointArray.RemoveSamePoint : 引数の数が合いません');
    }
    for (let i = 0; i < this.length; i += 1) {
      for (let cnt = i + 1; cnt < this.length; cnt += 1) {
        if (this[i].distanceTo(this[cnt]) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
          this.Remove(cnt);
          cnt -= 1;
        }
      }
    }
  }

  /*------------------------------------------------------
    * 配列内で１直線になる３点を見つけて、中間の点を削除する
    *
    */
  public RemoveOnlinePoint() {
    for (let idx = 0; idx < this.length; idx += 1) {
      const idx2 = (idx + 1) % this.length;
      const idx3 = (idx + 2) % this.length;
      const s = this[idx];
      const m = this[idx2];
      const e = this[idx3];
      if (s.distanceTo(e) > marietta3d.AutoGen.utils.ALMOST_ZERO) {
        /* s e は別座標 */
        const ln = new marietta3d.AutoGen.utils.RoomEdge();
        ln.GetPointFrom(s, e);
        if (Math.abs(ln.DistancePtoLine(m)) < marietta3d.AutoGen.utils.ALMOST_ZERO) {
          /* ３点が直線上にある */
          this.Remove(idx2);
          idx -= 1;
        }
      } else {
        /* s と e が一致（「行って来い」になっている */
        this.splice(idx2, 2); /* delete m, e */
        idx -= 1;
      }
    }
  }
}
